import { render } from "./AppTest.vue?vue&type=template&id=b63ca394&scoped=true"
import script from "./AppTest.vue?vue&type=script&lang=js"
export * from "./AppTest.vue?vue&type=script&lang=js"

import "./AppTest.vue?vue&type=style&index=0&id=b63ca394&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b63ca394"]])

export default __exports__